import {
    MixpanelPropertiesProvider,
    MixpanelProperty,
    PageViewTracker,
    RouteMixpanelPropertiesProvider,
    usePageTitleUpdater
} from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

const ProtectSource = {
    [MixpanelProperty.Source]: "ShareGate Protect"
};

/**
 * This provider is used for both public and private pages
 */
export function ModuleGlobalProviders({ children }: PropsWithChildren) {
    usePageTitleUpdater();

    return (
        <MixpanelPropertiesProvider value={ProtectSource}>
            <RouteMixpanelPropertiesProvider>
                {children}
                <PageViewTracker />
            </RouteMixpanelPropertiesProvider>
        </MixpanelPropertiesProvider>
    );
}
